export default {
  childUpdated: 'cu',
  childRemoved: 'cr',
  updated: 'u'
};
